export function objectKeys<Obj extends { [key: string]: any }>(
  obj: Obj,
): (keyof Obj)[] {
  return Object.keys(obj ?? {}) as (keyof Obj)[]
}
